import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/contexts/AuthContext";
import { useRole } from "@/hooks/useRole";

const MinimalistCTA = () => {
  const { isAuthenticated } = useAuth();
  const { roles } = useRole();

  const teacherLink = isAuthenticated && roles.includes('teacher') ? '/teacher/dashboard' : '/auth';
  const studentLink = isAuthenticated && roles.includes('student') ? '/student/dashboard' : '/auth';
  return (
    <section className="py-24 px-6">
      <div className="container mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="relative rounded-[2rem] overflow-hidden bg-primary py-20 md:py-28 px-8 text-center"
        >
          {/* Background brand text */}
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none">
            <h3 className="text-[15vw] font-black text-foreground/[0.05] leading-none tracking-tighter">
              EduLabs
            </h3>
          </div>

          <div className="relative z-10 max-w-2xl mx-auto">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-foreground leading-tight tracking-tight mb-6">
              Ready to start learning?
            </h2>
            <p className="text-lg text-foreground/70 mb-10 max-w-lg mx-auto">
              Join thousands of students and educators using EduLabs to create better learning experiences.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                asChild
                size="lg"
                className="rounded-full px-10 py-7 text-base font-bold bg-foreground text-background hover:bg-foreground/90 shadow-xl"
              >
                <Link to={teacherLink}>
                  Join as a Teacher <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
              <Button
                asChild
                variant="outline"
                size="lg"
                className="rounded-full px-10 py-7 text-base font-bold border-foreground/20 text-foreground hover:bg-foreground/5"
              >
                <Link to={studentLink}>Join as a Student</Link>
              </Button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default MinimalistCTA;
